export const typeFilterOptions = [
  { id: 1, name: 'Point' },
  { id: 2, name: 'City' },
  { id: 3, name: 'State' },
  { id: 4, name: 'Pincode' },
  { id: -1, name: 'All Types' },
];

export const filters = {
  TYPE: 'Type',
};
